export function roundCurrency(value) {
  return Number(Number(value || 0).toFixed(2));
}

export function getAffiliateBonusState(user = {}) {
  return {
    locked: roundCurrency(user?.affiliateBonusLocked || 0),
    unlocked: roundCurrency(user?.affiliateBonusUnlocked || 0),
    required: roundCurrency(user?.affiliateBonusTurnoverRequired || 0),
    completed: roundCurrency(user?.affiliateBonusTurnoverCompleted || 0),
  };
}

export function buildAffiliateTurnoverUpdate(user = {}, wagerAmount = 0) {
  const locked = roundCurrency(user?.affiliateBonusLocked || 0);
  const unlocked = roundCurrency(user?.affiliateBonusUnlocked || 0);
  const required = roundCurrency(user?.affiliateBonusTurnoverRequired || 0);
  const completed = roundCurrency(user?.affiliateBonusTurnoverCompleted || 0);
  const wager = roundCurrency(wagerAmount);

  if (locked <= 0 || required <= 0 || wager <= 0) {
    return { fields: {}, unlockedNow: false };
  }

  const nextCompleted = roundCurrency(Math.min(required, completed + wager));
  const unlockedNow = nextCompleted >= required;

  if (unlockedNow) {
    return {
      unlockedNow: true,
      fields: {
        affiliateBonusLocked: 0,
        affiliateBonusUnlocked: roundCurrency(unlocked + locked),
        affiliateBonusTurnoverRequired: 0,
        affiliateBonusTurnoverCompleted: 0,
      },
    };
  }

  return {
    unlockedNow: false,
    fields: {
      affiliateBonusTurnoverCompleted: nextCompleted,
    },
  };
}

export function getWithdrawableBalance(user = {}) {
  const balance = roundCurrency(user?.balance || 0);
  const depositAmount = roundCurrency(user?.depositAmount || 0);
  const depositBonus = roundCurrency(user?.bonusAmount ?? user?.depositBonus ?? 0);
  const turnoverRequired = roundCurrency(user?.turnoverRequired || 0);
  const turnoverCompleted = roundCurrency(user?.turnoverCompleted || 0);
  const affiliateLocked = roundCurrency(user?.affiliateBonusLocked || 0);

  const hasDepositBonusLock = depositBonus > 0 && turnoverRequired > 0 && turnoverCompleted < turnoverRequired;
  const baseAvailable = hasDepositBonusLock ? Math.min(balance, depositAmount) : balance;

  return Math.max(0, roundCurrency(baseAvailable - affiliateLocked));
}

export function getTotalVisibleBonus(user = {}) {
  return roundCurrency(
    Number(user?.bonusAmount ?? user?.depositBonus ?? 0) +
      Number(user?.affiliateBonusLocked || 0) +
      Number(user?.affiliateBonusUnlocked || 0),
  );
}
